/* eslint-disable prettier/prettier */
import { useEffect, useState } from 'react'

import { useFormik } from 'formik'
import * as Yup from 'yup'

import store from 'store'
import { useRef } from 'react'
import { brandsService, mediaService } from 'services'

import { _object } from 'utils/interfaces'

import { Button, InputField } from '../form-inputs'
import { toast } from 'react-toastify'
import { DeleteIcon } from 'assets/svg'

const EditBrandModal = (props: _object) => {
  const [brand, setBrand] = useState<_object>({})
  const [loading, setLoading] = useState(false)
  const [selectedFile, setSelectedFile] = useState<any>(null)
  const [isUploading, setIsUploading] = useState(false)
  const closeBtnRef = useRef<HTMLButtonElement | null>(null)

  const brandSlide = () => {
    brandsService.getBrandsDetails(props?.id).then((results: _object) => {
      setBrand(results)
    })
  }

  useEffect(() => {
    brandSlide()
  }, [props?.id])

  const validationSchema = Yup.object({
    title: Yup.string().label('Title').required(),
    description: Yup.string().label('description').required()
  })
  const formik: any = useFormik({
    initialValues: {
      title: brand?.title || '',
      description: brand?.description || '',
      featured: brand?.featured || false
    },
    enableReinitialize: true,
    validationSchema,
    onSubmit: (values) => {
      setLoading(true)
      brandsService.UpdateBrand(props?.id, values).then((results: _object) => {
        if (results?.error === false) {
          setLoading(false)
          closeBtnRef.current?.click()
        }
      })
    }
  })

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files ? e.target.files[0] : null
    if (file) {
      setSelectedFile(file)
    }
  }
  useEffect(() => {
    if (!selectedFile) return
    setIsUploading(true)

    const uploadImage = async () => {
      const data = new FormData()
      if (brand.id) {
        data.append('key', 'brand_image')
        data.append('entity_id', brand.id)
      }
      data.append('entity_type', 'brand')
      data.append('files', selectedFile)
      const accessToken = store.get(process.env.REACT_APP_ACCESS_TOKEN_KEY || '')

      const response = await fetch(`${process.env.REACT_APP_BASE_URL}/media`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          Authorization: accessToken ? accessToken : ''
        },
        body: data
      })

      const result = await response.json()
      if (result.error === false) {
        toast.success(result.message || 'Image uploaded successfully.', {
          autoClose: 3000
        })
        brandSlide()
      } else if (result.error === true) {
        toast.error(result.message || 'Image not uploaded.', {
          autoClose: 3000
        })
      }
      setIsUploading(false)
    }

    uploadImage()
  }, [selectedFile])

  const deleteSlide = (id: string) => {
    if (window.confirm('Are you sure you want to delete this slide?')) {
      mediaService.deleteMediaData(id).then((results: _object) => {
        if (results?.error === false) {
          brandSlide()
        }
      })
    }
  }
  return (
    <div
      id={`band-modal${props?.id}`}
      tabIndex={-1}
      aria-hidden="true"
      className="fixed top-0 right-0 left-0 z-50 flex hidden h-[calc(100%-1rem)] max-h-full w-full items-center justify-center overflow-x-hidden overflow-y-auto md:inset-0"
    >
      <div className="relative max-h-full w-full max-w-2xl p-4">
        {/* Modal Content */}

        <div className="relative z-10 max-h-full w-full max-w-2xl p-4">
          <div className="relative rounded-lg border border-gray-200 bg-white shadow-sm">
            <div className="flex items-center justify-between rounded-t border-b border-gray-200 p-3 px-5">
              <h3 className="text-lg font-semibold">Edit Brand</h3>
              <button
                type="button"
                className="ms-auto inline-flex h-8 w-8 items-center justify-center rounded-lg bg-transparent text-sm text-gray-400"
                data-modal-hide={`band-modal${props?.id}`}
                ref={closeBtnRef}
              >
                <svg
                  className="h-3 w-3"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 14 14"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                  />
                </svg>
                <span className="sr-only">Close modal</span>
              </button>
            </div>
            {props && (
              <form onSubmit={formik.handleSubmit} className="p-5">
                <div className="mb-4">
                  <InputField
                    label="Title"
                    name="title"
                    type="text"
                    placeholder="Title"
                    onChange={formik.handleChange}
                    value={formik.values.title}
                    onBlur={formik.handleBlur}
                    error={formik.touched.title && formik.errors.title}
                    required
                  />
                </div>

                <div className="mb-4">
                  <label className="mb-2 flex text-sm leading-none font-medium text-gray-700">
                    Description
                    <span className="text-red-500">*</span>
                  </label>
                  <textarea
                    id="description"
                    name="description"
                    rows={4}
                    className="w-full rounded-md border border-transparent bg-gray-100 px-3 py-2 text-black placeholder-gray-500 focus:border-gray-400 focus:outline-none"
                    placeholder="descripiton"
                    onChange={formik.handleChange}
                    value={formik.values.description}
                    required
                  ></textarea>
                </div>
                <div className="mb-4">
                  <label className="mb-2 flex text-sm leading-none font-medium text-gray-700">
                    Featured <span className="text-red-500">*</span>
                  </label>
                  <div className="flex gap-6">
                    <label className="flex items-center gap-2 text-sm text-gray-700">
                      <input
                        type="radio"
                        name="featured"
                        value="true"
                        checked={formik.values.featured === true}
                        onChange={(e) =>
                          formik.setFieldValue('featured', e.target.value === 'true')
                        }
                        onBlur={formik.handleBlur}
                        required
                      />
                      Yes
                    </label>

                    <label className="flex items-center gap-2 text-sm text-gray-700">
                      <input
                        type="radio"
                        name="featured"
                        value="false"
                        checked={formik.values.featured === false}
                        onChange={(e) =>
                          formik.setFieldValue('featured', e.target.value === 'true')
                        }
                        onBlur={formik.handleBlur}
                        required
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className="mb-4">
                  {brand?.media?.length > 0 ? (
                    <div className="relative inline-block h-[120px] w-[120px]">
                      <img
                        src={brand?.media[0]?.path}
                        alt={brand.title}
                        className="h-full w-full object-cover rounded-md"
                      />
                      <button
                        type="button"
                        onClick={() => deleteSlide(brand?.media[0]?.id)}
                        title="Delete Slide"
                        className="absolute top-1 right-1 rounded-full bg-white p-1 shadow-sm hover:bg-gray-100"
                      >
                        <DeleteIcon className="h-[20px] w-[20px] text-red-500" />
                      </button>
                    </div>
                  ) : (
                    <>
                      <label className="mb-2 flex text-sm leading-none font-medium text-gray-700">
                        Deal Image <span className="text-red-500">*</span>
                      </label>
                      <span className="text-[10px] text-[#969494] mb-4 block">275W × 183H | 3:2</span>
                      <label htmlFor="imageUpload">
                        <div className="relative flex h-32 w-32 cursor-pointer items-center justify-center rounded-md border-2 border-dashed border-purple-900">
                          <input
                            type="file"
                            id="imageUpload"
                            accept=".png, .jpg, .jpeg"
                            onChange={handleImageChange}
                            className="absolute inset-0 z-10 cursor-pointer opacity-0"
                          />
                          {isUploading ? (
                            <svg
                              className="h-8 w-8 animate-spin text-purple-900"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                            >
                              <circle
                                className="opacity-25"
                                cx="12"
                                cy="12"
                                r="10"
                                stroke="currentColor"
                                strokeWidth="4"
                              ></circle>
                              <path
                                className="opacity-75"
                                fill="currentColor"
                                d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                              ></path>
                            </svg>
                          ) : (
                            <span className="text-4xl font-bold text-purple-900">+</span>
                          )}
                        </div>
                      </label>
                    </>
                  )}
                </div>
                <Button
                  label="Save Changes"
                  type="submit"
                  className={`rounded-lg bg-purple-900 py-2 text-center text-sm text-white transition hover:bg-purple-950 ${loading == true && 'opacity-50 hover:bg-purple-950 is-loading'}`}
                  loading={loading}
                  disabled={!formik.isValid}
                />
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default EditBrandModal
